export default function Logo({ size = 26, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Traina"
    >
      <rect width="64" height="64" rx="14" fill="url(#traina-logo-gradient)" />
      <rect x="12" y="16" width="40" height="9" rx="2" fill="#ffffff" />
      <rect x="27.5" y="25" width="9" height="23" rx="2" fill="#ffffff" />
      <defs>
        <linearGradient id="traina-logo-gradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#1a3560" />
          <stop offset="100%" stopColor="#0a1525" />
        </linearGradient>
      </defs>
    </svg>
  );
}
